export default function Partners() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-red-500 to-red-600 bg-clip-text text-transparent mb-4">
            Conheça nossos parceiros
          </h2>
        </div>

        <div className="flex justify-center">
          <img 
            src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/f73d70397b616e431a97889ab680b160.png"
            alt="Parceiros The Joy School - Zoom Education, Layers Education e SAS Plataforma de Educação"
            className="w-full h-auto"
          />
        </div>
      </div>
    </section>
  );
}
